import { render, staticRenderFns } from "./LicencesSetup.vue?vue&type=template&id=1f0d5180&"
import script from "./LicencesSetup.vue?vue&type=script&lang=js&"
export * from "./LicencesSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\websites\\newshop\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f0d5180')) {
      api.createRecord('1f0d5180', component.options)
    } else {
      api.reload('1f0d5180', component.options)
    }
    module.hot.accept("./LicencesSetup.vue?vue&type=template&id=1f0d5180&", function () {
      api.rerender('1f0d5180', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/LicencesSetup.vue"
export default component.exports